import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App.jsx";
import "./index.css";
import { applyBranding, loadSavedBranding } from "./shared/utils/appBranding.js";

// Apply the last known company branding (app name/icon) before the first render,
// so the login screen and install prompt are already branded
applyBranding(loadSavedBranding());

// Register Service Worker for PWA with auto-update detection
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("[PWA] Service Worker registered:", reg.scope);

        // Check for updates on load and when app returns to foreground
        reg.update();
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            reg.update();
          }
        });

        // Auto reload when the updated Service Worker takes control
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (!refreshing) {
            refreshing = true;
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        console.warn("[PWA] Service Worker registration failed:", err);
      });
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
